import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { FootballRivalsOutcome } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { DisplayM, DisplayS } from '@sorare/core/src/atoms/typography';
import { RivalsLightning } from '@sorare/core/src/components/rivals/RepScore/RivalsLightning';

import { DoubleAnimatedDiamond } from 'components/rivals/Arena/ArenaStory/ArenaStoryElement/DoubleAnimatedDiamond';
import { ContentUnitLayout } from 'components/rivals/seasons/WelcomeToTheArena/ContentUnitLayout';
import { Description } from 'components/rivals/seasons/WelcomeToTheArena/Description';
import { useOutcomeConfig } from 'components/rivals/useOutcomeConfig';

const Root = styled(ContentUnitLayout)`
  position: relative;
  overflow: hidden;
  isolation: isolate;
  background: linear-gradient(
    to bottom,
    rgba(var(--bg-color), 0.4) 20%,
    rgba(var(--c-rgb-neutral-100), 0.2) 50%,
    rgba(var(--bg-color), 0.4) 80%
  );
`;
const OutcomeWrapper = styled.div`
  z-index: -1;
  isolation: isolate;
`;
const IconWrapper = styled.div`
  padding-top: var(--intermediate-unit);

  & > svg {
    width: var(--double-unit);
  }
`;

type Props = { outcome?: FootballRivalsOutcome };
export const EarnRep = ({ outcome = FootballRivalsOutcome.WIN }: Props) => {
  const { color, text, points } = useOutcomeConfig(outcome);

  return (
    <Root style={{ '--bg-color': color } as CSSProperties}>
      <DisplayS>
        <FormattedMessage
          id="WelcomeToTheArena.EarnRep.title"
          defaultMessage="Earn Rep"
        />
      </DisplayS>
      <OutcomeWrapper>
        <DoubleAnimatedDiamond
          color={color}
          text={text}
          animateText={false}
          fadeAway={false}
          extra={
            <Horizontal gap={0.5}>
              <DisplayM>
                <FormattedNumber value={points} signDisplay="exceptZero" />
              </DisplayM>
              <IconWrapper>
                <RivalsLightning fill="var(--c-rivals-reputation)" />
              </IconWrapper>
            </Horizontal>
          }
        />
      </OutcomeWrapper>
      <Description>
        <FormattedMessage
          id="WelcomeToTheArena.EarnRep.description"
          defaultMessage="Beat your opponents and win Reputation points"
        />
      </Description>
    </Root>
  );
};
